jQuery.noConflict();
(function ($) {
    var baseUrl = 'https://ac-web2.api.everforth.com/capi';
    var defaultQuery = {
        limit: '2'
    };
    var attrs = ['apikey', 'limit', 'start', 'brands', 'tags', 'used_by', 'using_to_product_number', 'ids', 'with', 'staff.id', 'staff.height', 'staff.gender', 'freetext1', 'shops', 'shop.freetext1', 'webapi.timezone'];
    var templateAttrs = ['src', 'href', 'alt', 'title'];
    var prefix = 'ef-';

    $.ef_ajax = function (path, options) {
        options['url'] = baseUrl + '/' + path;
        options['dataType'] = 'jsonp';
        $.ajax(options);
    };

    $.fn.ef = function (path, params) {
        if (this.length) {
            var target = jQuery(this);
            var query = jQuery.extend(true, {}, defaultQuery);
            for (a in params) {
                query[a] = params[a]
            }
            attrs.forEach(function (attr) {
                var value = target.attr(prefix + attr);
                if (value) query[attr] = value;
            });
            var item = $('.' + prefix + 'item', target);
            if(path == 'shopData') {
              setShopData('shop', query, item);
            } else {
              if (item) ef_jsonp(path, query, item);
            }
        }
        return this;
    };

    function ef_jsonp(path, query, item) {
        item.hide();
        $.ajax({
            url: baseUrl + '/' + path,
            data: query,
            dataType: 'jsonp',
            success: function (json) {
                var datas = json['data'];
                datas.forEach(function (data) {
                    var clone = item.clone();
                    clone.show();

                    for (attr in data) {
                        if (clone.hasClass(prefix + attr)) {
                            clone.text(data[attr])
                        }
                        templateAttrs.forEach(function (viewAttr) {
                            if (clone.hasClass(prefix + attr + "-" + viewAttr)) {
                                clone.attr(viewAttr, data[attr])
                            }
                        });
                        $('.' + prefix + attr, clone).text(data[attr]);
                        templateAttrs.forEach(function (viewAttr) {
                            $('.' + prefix + attr + "-" + viewAttr, clone).attr(viewAttr, data[attr]);
                        })
                    }

                    //template
                    var processTemplate = function (text) {
                        if (text) for (attr in data) {
                            if (data[attr]) text = text.split('{{' + attr + '}}').join(data[attr])
                        }
                        return text;
                    }

//                    if (clone.hasClass(prefix + 'template')) {
//                        clone.text(function(index, text) {
//                            return processTemplate(text);
//                        })
//                    }
                    if (clone.hasClass(prefix + 'template')) {
                        clone.html(function (index, html) {
                            return processTemplate(html);
                        })
                    }
                    templateAttrs.forEach(function (viewAttr) {
                        if (clone.hasClass(prefix + 'template' + "-" + viewAttr)) {
                            clone.attr(viewAttr, processTemplate(clone.attr(viewAttr)))
                        }
                    });
//                    $('.' + prefix + 'template', clone).text(function(index, text) {
//                        return processTemplate(text);
//                    });
                    $('.' + prefix + 'template', clone).html(function (index, html) {
                        return processTemplate(html);
                    });
                    templateAttrs.forEach(function (viewAttr) {

                        $('.' + prefix + 'template' + "-" + viewAttr, clone).each(function () {
                            $(this).attr(viewAttr, processTemplate($(this).attr(viewAttr)));
                        });

                    });

                    clone.insertBefore(item);
                });
                if(path == 'blog') {
                  loadMore();
                }
                item.remove();
            }
        });
    }

    function setShopData(path, query, item) {
      $.ajax({
            url: baseUrl + '/' + path,
            data: {
                "apikey": "aLCGohd8c53aw1bxDgk1esioECIXVhEG"
            },
            dataType: 'jsonp',
            success: function (json) {
                var datas = json['data'];
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                const blogId = params.get("blogid");
                const targetObject = datas.find(obj => obj.id === blogId);
                if (targetObject) {
                  const { zipcode, image_url, name, brand_name, address, latitude, longitude, tel, fax } = targetObject;
                
                  let template = "";

                   if (image_url) {
                    template += `<div class="apw-blog-list_shopimg-box"><img src="${image_url}" alt="画像"></div>`;
                  }

                  template += `<div class="apw-blog-list_shopcont-box">`;

                  if (name) {
                    template += `<h2>${name}</h2>`;
                  }
                
                  if (zipcode) {
                    template += `<p>〒${zipcode}<br>${address}<br>TEL : ${tel}</p>`;
                  }

                  if (latitude) {
                    template += `<div class="apw-blog-list_shoplink-box"><a href="https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}" target="_blank"><img src="//shopify-stage.mikihouse.co.jp/cdn/shop/t/21/assets/apw-blog_icon-map-pin.png" alt="MAP">MAP</a></div>`;
                  }

                  template += `</div>`;
                
                  const container = document.getElementById("apw-blog-shopinfo"); 
                
                  if (template !== "") {
                    container.innerHTML = template;
                  }

                  const shopName = document.getElementById("shopName"); 
                  shopName.innerHTML = `${name}`;

                } else {
                  console.log("指定したidのオブジェクトが見つかりませんでした。");
                }
            },
            error: function(xhr, status, error) {
                console.error('An error occurred:', error);
            }
      });
    }

    function loadMore() {
      //loadmore
      var $contentContainer = $("#contentContainer");
      var $loadMoreButton = $("#loadMoreButton");
      var $hiddenContent = $contentContainer.find("li.apw-blog-list_li").slice(9);
      $hiddenContent.hide();

      if ($hiddenContent.length === 0) {
        $loadMoreButton.hide(); // 表示するコンテンツがない場合はボタンを非表示にする
      }
    
      $loadMoreButton.on("click", function() {
        $hiddenContent.slice(0, 5).fadeIn(); 
        $hiddenContent = $hiddenContent.slice(5); 
        if ($hiddenContent.length === 0) {
          $loadMoreButton.hide(); // 表示するコンテンツがない場合はボタンを非表示にする
        }
      });
    }

    //jQuery('.ef-shops').each(function() {
    //  jQuery(this).ef('shop');
    //});
    jQuery('.ef-blogs').each(function() {
      jQuery(this).ef('blog');
    });
    if (window.location.pathname === "/pages/apw-blog-list") {
      jQuery(this).ef('shopData');//shop情報の取得
    }
    
})(jQuery);



/* 
jQuery.noConflict();
(function ($) {
  var baseUrl = 'https://ac-web2.api.everforth.com/capi';
  var defaultQuery = {
    limit: '2'
  };
  var attrs = ['apikey', 'limit', 'start', 'brands', 'tags', 'used_by', 'using_to_product_number', 'with', 'staff.id', 'staff.height', 'staff.gender'];
  var templateAttrs = ['src', 'href', 'alt', 'title'];
  var prefix = 'ef-';

  $.ef_ajax = function (path, options) {
      options['url'] = baseUrl + '/' + path;
      options['dataType'] = 'jsonp';
      $.ajax(options);
  };

  $.fn.ef = function (path, params) {
      if (this.length) {
          var target = jQuery(this);
          var query = jQuery.extend(true, {}, defaultQuery);
          for (a in params) {
              query[a] = params[a]
          }
          attrs.forEach(function (attr) {
              var value = target.attr(prefix + attr);
              if (value) query[attr] = value;
          });
          var item = $('.' + prefix + 'item', target);
          if (item) ef_jsonp(path, query, item);
      }
      return this;
  };

  function ef_jsonp(path, query, item) {
    item.hide();
    $.ajax({
      url: baseUrl + '/' + path,
      data: query,
      dataType: 'jsonp',
      success: function (json) {
        var datas = json['data'];
        datas.forEach(function (data) {
          var clone = item.clone();
          clone.show();

          for (attr in data) {
              if (clone.hasClass(prefix + attr)) {
                  clone.text(data[attr])
              }
              templateAttrs.forEach(function (viewAttr) {
                  if (clone.hasClass(prefix + attr + "-" + viewAttr)) {
                      clone.attr(viewAttr, data[attr])
                  }
              });
              $('.' + prefix + attr, clone).text(data[attr]);
              templateAttrs.forEach(function (viewAttr) {
                  $('.' + prefix + attr + "-" + viewAttr, clone).attr(viewAttr, data[attr]);
              })
          }

          //template
          var processTemplate = function (text) {
              if (text) for (attr in data) {
                  if (data[attr]) text = text.split('{{' + attr + '}}').join(data[attr])
              }
              return text;
          }

//                    if (clone.hasClass(prefix + 'template')) {
//                        clone.text(function(index, text) {
//                            return processTemplate(text);
//                        })
//                    }
          if (clone.hasClass(prefix + 'template')) {
              clone.html(function (index, html) {
                  return processTemplate(html);
              })
          }
          templateAttrs.forEach(function (viewAttr) {
              if (clone.hasClass(prefix + 'template' + "-" + viewAttr)) {
                  clone.attr(viewAttr, processTemplate(clone.attr(viewAttr)))
              }
          });
//                    $('.' + prefix + 'template', clone).text(function(index, text) {
//                        return processTemplate(text);
//                    });
          $('.' + prefix + 'template', clone).html(function (index, html) {
            return processTemplate(html);
          });
          templateAttrs.forEach(function (viewAttr) {

              $('.' + prefix + 'template' + "-" + viewAttr, clone).each(function () {
                  $(this).attr(viewAttr, processTemplate($(this).attr(viewAttr)));
              });

          });

          clone.insertBefore(item);
        });
        item.remove();
      }
    });
  }
  $('.ef-productclasses').ef('productclass');
  $('.ef-shops').ef('shop');
  $('.ef-snaps').ef('snap');
  $('.ef-blogs').ef('blog');
  $('.ef-news').ef('news');
})(jQuery);
*/